import React, { useState, useContext } from "react";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import { TabPanel, useTabStyle } from "App/Component/ui";
import { BILLING_INPUT_PENJUALAN } from "App/constants";
import { removeLocalStorageAsFormData } from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import { TabBarang, TabJasa, TabFasilitas, TabRikjang, TabPaket } from "..";
import { RESET_STATE_INPUT_PENJUALAN } from "../helpers";
import { useDaftarBarangGudang } from "../hooks/useDaftarBarangByGudang";
import { useDaftarJasaByKelas } from "../hooks/useDaftarJasaByKelas";
import { useDaftarFasilitasByKelas } from "../hooks/useDaftarFasilitasByKelas";
import { useDaftarRikjangByKelas } from "../hooks/useDaftarRikjangByKelas";
import { useDaftarPaketByKelas } from "../hooks/useDaftarPaketByKelas";

function a11yProps(index) {
  return {
    id: `tab-panel-${index}`,
    "aria-controls": `TabPanel-${index}`,
  };
}

export default function TabMaster() {
  const classes = useTabStyle();
  const [value, setValue] = useState(0);
  const { setFormData } = useContext(FormContext);

  const [perhitunganPenjualan, setPerhitunganPenjualan] = useState({
    jumlah: 0,
    sub_total: 0,
    tax_number: 0,
    total: 0,
    pembayaran: 0,
    sisa: 0,
    total_barang: 0,
    total_jasa: 0,
  });

  /**
   * Data barang by gudang
   * penaamaan salah, karena perubahan alur di tengah develop
   *
   */

  const {
    formFilterBarangByKelas,
    setFormFilterBarangByKelas,
    setNewDataBarangByKelas,
    totalDataBarangByKelas,
    loadingBarangByKelas,
    rowsBarangByKelas,
  } = useDaftarBarangGudang();

  // END BARANG

  const {
    formFilterJasaByKelas,
    setFormFilterJasaByKelas,
    setNewDataJasaByKelas,
    totalDataJasaByKelas,
    loadingJasaByKelas: loadingJasa,
    rowsJasaByKelas,
  } = useDaftarJasaByKelas();

  // END JASA

  /**
   * Data Fasilitas By Kelas
   */

  const {
    formFilterFasilitasByKelas,
    setFormFilterFasilitasByKelas,
    setNewDataFasilitasByKelas,
    totalDataFasilitasByKelas,
    loadingFasilitasByKelas: loadingFasilitas,
    rowsFasilitasByKelas,
  } = useDaftarFasilitasByKelas();
  // END FASILITAS

  /**
   * Data Rikjang
   */

  const {
    formFilterRikjangByKelas,
    setFormFilterRikjangByKelas,
    setNewDataRikjangByKelas,
    totalDataRikjangByKelas,
    loadingRikjangByKelas: loadingRikjang,
    rowsRikjangByKelas,
  } = useDaftarRikjangByKelas();

  // END RIKJANG

  /**
   * Data Paket
   */

  const {
    formFilterPaketByKelas,
    setFormFilterPaketByKelas,
    setNewDataPaketByKelas,
    totalDataPaketByKelas,
    loadingPaketByKelas: loadingPaket,
    rowsPaketByKelas,
  } = useDaftarPaketByKelas();
  // END PAKET

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickReset = () => {
    setFormData(RESET_STATE_INPUT_PENJUALAN);
    removeLocalStorageAsFormData(BILLING_INPUT_PENJUALAN);
  };

  return (
    <div className={classes.root}>
      <div className={classes.rootTab}>
        <AppBar
          position='static'
          classes={{
            root: classes.appbar,
          }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant='fullWidth'
            aria-label='Tabs Input Penjualan'
            classes={{
              root: classes.tabs,
              flexContainer: classes.fixedTab,
            }}>
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='BARANG'
              {...a11yProps(0)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='JASA'
              {...a11yProps(1)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='FASILITAS'
              {...a11yProps(2)}
            />
            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='RIKJANG'
              {...a11yProps(3)}
            />

            <Tab
              classes={{
                selected: classes.selected,
                fullWidth: classes.tab,
              }}
              label='PAKET'
              {...a11yProps(4)}
            />
          </Tabs>
        </AppBar>
        <TabPanel alwaysMount={false} value={value} index={0}>
          <TabBarang
            rowsBarangByKelas={rowsBarangByKelas}
            loadingBarangByKelas={loadingBarangByKelas}
            totalDataBarangByKelas={totalDataBarangByKelas}
            formFilterBarangByKelas={formFilterBarangByKelas}
            setFormFilterBarangByKelas={setFormFilterBarangByKelas}
            setNewDataBarangByKelas={setNewDataBarangByKelas}
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={1}>
          <TabJasa
            loading={loadingJasa}
            rowsJasaByKelas={rowsJasaByKelas}
            setNewDataJasaByKelas={setNewDataJasaByKelas}
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
            totalDataJasaByKelas={totalDataJasaByKelas}
            formFilterJasaByKelas={formFilterJasaByKelas}
            setFormFilterJasaByKelas={setFormFilterJasaByKelas}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={2}>
          <TabFasilitas
            loading={loadingFasilitas}
            rowsFasilitasByKelas={rowsFasilitasByKelas}
            setNewDataFasilitasByKelas={setNewDataFasilitasByKelas}
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
            totalDataFasilitasByKelas={totalDataFasilitasByKelas}
            formFilterFasilitasByKelas={formFilterFasilitasByKelas}
            setFormFilterFasilitasByKelas={setFormFilterFasilitasByKelas}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={3}>
          <TabRikjang
            loading={loadingRikjang}
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            setNewDataRikjangByKelas={setNewDataRikjangByKelas}
            rowsRikjangByKelas={rowsRikjangByKelas}
            handleClickReset={handleClickReset}
            totalDataRikjangByKelas={totalDataRikjangByKelas}
            formFilterRikjangByKelas={formFilterRikjangByKelas}
            setFormFilterRikjangByKelas={setFormFilterRikjangByKelas}
          />
        </TabPanel>
        <TabPanel alwaysMount={false} value={value} index={4}>
          <TabPaket
            loading={loadingPaket}
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            setNewDataPaketByKelas={setNewDataPaketByKelas}
            rowsPaketByKelas={rowsPaketByKelas}
            handleClickReset={handleClickReset}
            totalDataPaketByKelas={totalDataPaketByKelas}
            formFilterPaketByKelas={formFilterPaketByKelas}
            setFormFilterPaketByKelas={setFormFilterPaketByKelas}
          />
        </TabPanel>
      </div>
    </div>
  );
}
